var React = require('react');

function Max (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4","width":"2","height":"10","fill":"#222222","key":0}),React.createElement("rect",{"y":"6","width":"2","height":"10","transform":"rotate(-90 0 6)","fill":"#222222","key":1})]);
}

Max.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Max;

Max.default = Max;
